import React, { useEffect } from 'react';

import { ConversionsCollections } from '@components/ConversionsCollections';
import { SkeletonProductsFeed } from '@components/SkeletonProductsFeed';
import { renderProductCards } from '@utils/products';
import { novelties } from '@constants';
import {
  ClerkActionType,
  ClerkCategoryType,
  ClerkShowDayDiscountBlockEvent,
  ClerkShowNewArrivalsBlockEvent,
  ClerkSourceType,
  useClerk,
} from '@hook/useClerk';

import {
  useConversionsCollectionQuery,
} from './graphql.v3.generated';

export const ConversionsCollectionContainer: React.FC<{ slug: string, href: string }> = ({
  slug: collectionSlug,
  href,
}) => {
  const { sendClerkEvent } = useClerk();

  useEffect(
    () => {
      if (collectionSlug === novelties) {
        sendClerkEvent<ClerkShowNewArrivalsBlockEvent>({
          category: ClerkCategoryType.newArrivalsBlock,
          action: ClerkActionType.show,
          payload: {
            source: ClerkSourceType.personalNewArrivalsBlock,
          },
        });
      } else {
        sendClerkEvent<ClerkShowDayDiscountBlockEvent>({
          category: ClerkCategoryType.dayDiscountBlock,
          action: ClerkActionType.show,
          payload: {
            source: ClerkSourceType.personalDayDiscountBlock,
          },
        });
      }
    },
    [collectionSlug, sendClerkEvent],
  );

  const { data, loading, error } = useConversionsCollectionQuery({
    variables: {
      collectionSlug,
    },
  });

  if (error) {
    throw error;
  }

  if (loading && !data) {
    return (
      <SkeletonProductsFeed count={30} />
    );
  }

  const dynamicCollectionData = data?.dynamicCollection;

  if (dynamicCollectionData) {
    const productsList = renderProductCards(data?.dynamicCollection.products.edges || []);
    return (
      <ConversionsCollections
        href={href}
        products={productsList || []}
        isDynamicCollection={true}
        slug={collectionSlug}
      />
    );
  }

  return null;
};

export default ConversionsCollectionContainer;
